import { Chip, Typography } from '@mui/material';
import { FormattedNumber } from 'react-intl';

export function PriceTypography({ price, originalPrice }) {
  const hasDiscount = originalPrice && originalPrice > price;

  return (
      <Typography variant="h6">
        {hasDiscount ? (
          <>
            <span style={{ textDecoration: 'line-through', color: '#999', marginRight: 8 }}>
            {/* eslint-disable react/style-prop-object */}
              <FormattedNumber value={originalPrice} style="currency" currency="ZAR" />
            </span>
            <FormattedNumber value={price} style="currency" currency="ZAR" />
            <Chip
              label={`Save R${originalPrice - price}`}
              size="small"
              color="success"
              sx={{ ml: 1, mb: 0.5}}
            />
          </>
        ) : (
          <FormattedNumber value={price} style="currency" currency="ZAR" />
        )}
      </Typography>
  );
};
